// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UYKr","questions":"styles_questions__P7-dX","footer":"styles_footer__Zhiux"};